function showRecover() {
    document.getElementById('auth-page').classList.add('auth-page--recover-active');
}

function showLogin() {
    document.getElementById('auth-page').classList.remove('auth-page--recover-active');
}

document.addEventListener('DOMContentLoaded', function () {
    console.log('TEST');
    console.log(window.location.hash);
    if (window.location.hash === '#recover') {
        showRecover();
    }

    // click on back button and close modal
    document.querySelectorAll('.login-modal-close-button button').forEach(button => {        
        button.addEventListener('click', function () {
            window.history.back();
        });
    });
});
